export const PAGETITLE_SET = 'PAGETITLE_SET';
export const CURREENTMENU_SET = 'CURREENTMENU_SET';
export const BREADCRUMBS_SET = 'BREADCRUMBS_SET';